import React from 'react'
import AdminLayout from './AdminLayout'

const FavoriteBrands = () => {
  return (
    <AdminLayout>
        <div className="favoriteBrands">

            <h1 className='h1'>Любимые бренды <span className="ml-4"><img src="/assets/icon/save.svg" alt="" /></span></h1>

            <div className="card first">
                <div className="card-body">
                    <div className="img"><img src="/assets/image/logoAssist.png" alt="" /></div>
                    <div>
                        <h4>Название</h4>
                        <h5>Новые поступления: 35</h5>
                    </div>
                </div>
            </div>
            
            <div className="card">
                <div className="card-body">
                    <div className="img"><img src="/assets/image/logoAssist.png" alt="" /></div>
                    <div>
                        <h4>Название</h4>
                        <h5>Новые поступления: 35</h5>
                    </div>
                </div>
            </div>
            
            <div className="card">
                <div className="card-body">
                    <div className="img"><img src="/assets/image/logoAssist.png" alt="" /></div>
                    <div>
                        <h4>Название</h4>
                        <h5>Новые поступления: 35</h5>
                    </div>
                </div>
            </div>
            
            <div className="card">
                <div className="card-body">
                    <div className="img"><img src="/assets/image/logoAssist.png" alt="" /></div>
                    <div>
                        <h4>Название</h4>
                        <h5>Новые поступления: 35</h5>
                    </div>
                </div>
            </div>
            
            <div className="card">
                <div className="card-body">
                    <div className="img"><img src="/assets/image/logoAssist.png" alt="" /></div>
                    <div>
                        <h4>Название</h4>
                        <h5>Новые поступления: 35</h5>
                    </div>
                </div>
            </div>
            
            <div className="card">
                <div className="card-body">
                    <div className="img"><img src="/assets/image/logoAssist.png" alt="" /></div>
                    <div>
                        <h4>Название</h4>
                        <h5>Новые поступления: 35</h5>
                    </div>
                </div>
            </div>
            
            <div className="card">
                <div className="card-body">
                    <div className="img"><img src="/assets/image/logoAssist.png" alt="" /></div>
                    <div>
                        <h4>Название</h4>
                        <h5>Новые поступления: 35</h5>
                    </div>
                </div>
            </div>

        </div>
    </AdminLayout>
  )
}

export default FavoriteBrands